import { AuthParamsType, FriendsListResponse, UpdateUserSettingsParamsType, UserInfo } from './types/types.ts'
import {
  GetProfileResponseType,
  ReferralHistoryResponse,
  UsersByGamedIdDTO,
  UsersByGamedIdResponse,
} from './types/dto.ts'
import { PaginationParams } from '@/shared/constants/types.ts'
import { http } from '@/shared/http.ts'

export const authReq = async (params: AuthParamsType) => {
  // TODO: clarify this type
  return await http.post<any>('/user/', {
    body: params,
  })
}

export const refreshToken = async (token: string) => {
  // TODO: clarify this type
  return await http.post<any>('/user/token', {
    token,
  })
}

export const postSubscribeToPlus = async (token: string, subscription_id: number) => {
  // TODO: clarify this type
  return await http.post<any>(
    '/payment/plus/purchase',
    {
      token,
      body: {
        subscription_id,
      },
    },
  )
}

export const postSubscribeToPlatinum = async (token: string, subscription_id: number) => {
  // TODO: clarify this type
  return await http.post<any>(
    '/payment/platinum/purchase',
    {
      token,
      body: {
        subscription_id,
      },
    },
  )
}

export const postPurchaseDiscount = async (token: string, subscription_id: number) => {
  // TODO: clarify this type
  return await http.post<any>(
    '/payment/platinum/purchase_discount',
    {
      token,
      body: {
        subscription_id,
      },
    },
  )
}

export const getSubscriptionPrices = async (token: string) => {
  // TODO: clarify this type
  return await http.get<any>('/payment/plus/prices', {
    token,
  })
}

export const insertUserSettings = async (props: UpdateUserSettingsParamsType) => {
  const { token, data } = props
  return await http.post('/user/setting', {
    token,
    body: {
      ...data,
    },
  })
}

export const getAllFriendsList = async (token: string, page: number, size: number): Promise<FriendsListResponse> => {
  return await http.get<FriendsListResponse>('/user/all-friends', {
    token,
    queryParams: {
      page,
      size,
    }
  })
}

export const postAddFriend = async (token: string, friend_tid: number) => {
  return await http.post('/user/add-friend/', {
    token,
    body: {
      friend_tid,
    }
  })
}

export const deleteRemoveFriend = async (token: string, friend_tid: number) => {
  return await http.delete('/user/delete-friend/', {
    token,
    body: {
      friend_tid,
    }
  })
}

export const getFriendStatus = async (token: string, friend_tid: number): Promise<boolean> => {
  return await http.get<boolean>('/user/is-friend', {
    token,
    queryParams: {
      friend_tid,
    }
  })
}
export const getUserInfo = async (token: string, user_tid: number) => {
  return await http.get<UserInfo>('/user/info', {
    token,
    queryParams: {
      user_tid,
    }
  })
}

export const getUserProfile = async (token: string) => {
  return await http.get<GetProfileResponseType>('/user/profile', {
    token,
  })
}

export const getFriendsReward = async (token: string) => {
  return await http.get<{ new_token_value: number, unclaimed_expire_at: string }>('/user/claim-referrals', {
    token,
  })
}

export const getReferralHistory = async ({token, page, size}: PaginationParams): Promise<ReferralHistoryResponse> => {
  return await http.get<ReferralHistoryResponse>('/user/ref-history/', {
    token,
    queryParams: {
      page,
      size,
    }
  })
}
export const getUsersByGamedId = async ({token, gamed_id, page, size}: UsersByGamedIdDTO): Promise<UsersByGamedIdResponse> => {
  return await http.get<UsersByGamedIdResponse>('/user/find-users', {
    token,
    queryParams: {
      gamed_id,
      page,
      size,
    }
  })
}
